export default class Localization {
    constructor(id = '') {
        this.name = "";
        this.language = "";
        this.currency = "";
        this.change = "";
        this.icon = "";
        this.iconURL = "";
        this.order = 0;
        this.id = id;
    }
}
